/**
 * Module definition houses all content widgets
 *
 * @module content.widgets
 */
angular.module('content.widgets', [
  'content.widgets.asfAddons',
  'content.widgets.choiceDecisionWidget',
  'content.widgets.contentWidget',
  'content.widgets.dcsWidget',
  'content.widgets.defaultWidget',
  'content.widgets.eventsWidget',
  'content.widgets.loWidget',
  'content.widgets.sbarWidget',
  'content.widgets.studentNotesWidget'
]);
